/* Blanche Noire premium page: scroll reveal + number count-up.
   Safe to load more than once (every bn- section requests it). */
(function () {
  if (window.bnPremium) return;
  window.bnPremium = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('[data-bn-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce || designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
    // Safety net: never leave content hidden.
    window.setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 8000);
  }

  function count(el) {
    var target = parseFloat(el.getAttribute('data-bn-count'));
    if (isNaN(target)) return;
    var start = null;
    var duration = 1600;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased);
      if (p < 1) window.requestAnimationFrame(frame);
      else el.textContent = target;
    }
    el.textContent = '0';
    window.requestAnimationFrame(frame);
  }

  function counters(scope) {
    var els = (scope || document).querySelectorAll('[data-bn-count]:not([data-bn-counted])');
    if (!els.length || reduce || designMode || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-bn-counted', '1');
        io.unobserve(entry.target);
        count(entry.target);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(scope) { reveal(scope); counters(scope); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
